import { createSlice } from '@reduxjs/toolkit';

export const serviceEditorSlice = createSlice({
  name: 'serviceEditor',
  initialState: {
    showServiceEditor: false,
    editingServiceId: '',
  },
  reducers: {
    toggleShowServiceEditor: (state) => {
      state.showServiceEditor = !state.showServiceEditor;
    },
    setEditingServiceId: (state, action) => {
      state.editingServiceId = action.payload;
    },
    clearEditingServiceId: (state) => {
      state.editingServiceId = '';
    },
  },
});

// export actions
export const {
  toggleShowServiceEditor,
  setEditingServiceId,
  clearEditingServiceId,
} = serviceEditorSlice.actions;

// export reducers
export default serviceEditorSlice.reducer;
